import {
  DEFAULT_NUMBER_FORMAT,
  isNumberFormat,
  type NumberFormat,
} from "components/v3/Header/AccountDropdown/NumberFormatSwitcher"
import { usePersistedState } from "./usePersistedState"

export function useNumberFormatter(): NumberFormat {
  const [numberFormat] = usePersistedState<string | undefined>(
    "number-format",
    undefined,
    "localStorage",
    true
  )
  return numberFormat && isNumberFormat(numberFormat)
    ? numberFormat
    : DEFAULT_NUMBER_FORMAT
}
